<template lang='pug'>
    v-dialog(
        v-model="dialog"
        persistent
        width="720"
        height="640"
    )
        template(v-slot:activator="{ on, attrs }")
            v-btn(
                cdepressed
                class="ml-3 text-capitalize btn-video elevation-0"
                v-bind="attrs"
                v-on="on"
            ) Watch Video

        v-card
            v-app-bar(class="elevation-0" color="white")
                v-spacer
                v-card-title.ml-lg-16 i-Memo Introduction Videos
                v-spacer
                v-btn(
                    @click="closeDialog"
                    class="elevation-0 transparent-bg"
                )
                    v-icon close 

            //- iframe(
            //-         src="assets/video/Generic-iMemo-Introduction.mp4" 
            //-         width="640" 
            //-         height="480" 
            //-         allow="autoplay"
            //-         allowfullscreen
            //-     )

            video(
                width="640"
                height="480"
                controls
                ref="myVideo"
            )
                source(:src="video" type="video/mp4")
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        video: require("../assets/video/tutorial-v1.mp4"),
      }
    },
    methods: {
        closeDialog() {
            this.dialog = false 
            this.$refs.myVideo.pause()
        }
    }
  }
</script>

<style scoped>
    video {
        display: block;
        border-style:none;
        margin-left: auto; 
        margin-right: auto;
        padding-bottom: 2rem;
    }

    @media(max-width: 576px){
        video{
            width: 320px;
            height: 240px;
        }
    }

    .transparent-bg{
        background: transparent !important;
    }
</style>
